import action from './action.js';
import { baseUrl, OSS_URL, AREA_OSS } from '../config';

export default class request {
    static get(address, params) {
        let url = address;
        if(address && (address.indexOf(AREA_OSS) < 0)) {
            url = baseUrl + address;
        }
        return action.get(url, params);
    }

    static post(address, data) {
        let url = baseUrl + address;
        return action.post(url, data);
    }

    static put(address, data) {
        let url = baseUrl + address;
        return action.put(url, data);
    }

    static delete(address, data) {
        let url = baseUrl + address;
        return action.delete(url, data);
    }

    static upPic(data) {
        let url = baseUrl + '/common/upload';
        return action.upPic(url, data);
    }

    static upFile(address, data) {
        let url = baseUrl + address;
        return action.upFile(url, data);
    }
}
